import OvertimeIndex from "./OvertimeIndex.vue";
import OvertimeAdd from "./OvertimeAdd.vue";
import OvertimeDetail from "./OvertimeDetail.vue";

let routes= [
    {
        path: '',
        meta: {
          title: "List Overtime",
        },
        name: "OvertimeIndex",
        component: OvertimeIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create Overtime",
        },
        name: "OvertimeAdd",
        component: OvertimeAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Overtime",
        },
        name: "OvertimeDetail",
        component: OvertimeDetail
    },
    
]

export default routes
  